<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col
        lg="12"
        style="display:block; text-align:center;padding-bottom:15px;font-size:1.2em;"
        v-if="total > 0"
      >
        <span style="padding:5px;">Total Records:</span>
        <b style="border-right:1px solid white; padding-right:5px;">{{
            total
          }}</b>
        <span style="padding:5px;">Total Price:</span>
        <b
        >${{
            totalPrice.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
          }}</b
        >
        <b-button
          class="download-button"
          variant="primary"
          size="lg"
          @click="downloadExcel()"
        >
          <LoadingCard
            height="20px"
            width="20px"
            v-if="loading2019"
          ></LoadingCard>
          <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>
          Download
        </b-button>
      </b-col>
      <b-col lg="12">
        <c-table
          :table-data="data"
          :fields="fields"
          :caption="title"
          :noDataMessage="message"
          :loading="loading"
        ></c-table>
      </b-col>
    </b-row>
    <b-row style="display:flex; justify-content: center;">
      <LoadingCard v-if="loading"></LoadingCard>
    </b-row>
  </div>
</template>

<script>
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import cTable from "./Table.vue";

export default {
  props: [
    "location",
    "productGroup",
    "type",
    "date_from",
    "date_to",
    "year",
    "month",
    "prodModel",
    "customer",
    "productModel",
    "prg",
    "clients",
    "failure",
    "fns_part",
    "client",
    "city"
  ],
  name: "tables",
  components: { cTable, LoadingCard },
  data: () => {
    return {
      locationParam: "",
      excelDownloadUrl: "",
      excelDownloadParams: {
        xml: "true"
      },
      message: "",
      loading2019: false,
      loadingExcel: false,
      clientsId: "",
      productGroupParam: "",
      dateFromParam: "",
      modelParam: "",
      dateToParam: "",
      selectedYear: "",
      selectedMonth: "",
      product: "",
      manufacturer: "",
      title: "",
      loading: true,
      data: [],
      total: 0,
      totalPrice: 0,
      fields: [
        { key: "fnsid", label: "FNSID", sortable: true },
        { key: "locat", label: "Location" },
        { key: "sernm", label: "Serial#" },
        {
          key: "pMake",
          label: "Manufacturer",
          sortable: true,
          style: "width: 250px"
        },
        { key: "pMode", label: "Model" },
        {
          key: "compl",
          label: "Complaint",
          sortable: true,
          tdClass: "complaintClass"
        },
        { key: "loctn", label: "Status", sortable: true },
        { key: "price", label: "Price", sortable: true }
      ]
    };
  },
  methods: {
    setTableBacklogColumns(schemaName) {
      this.fields = [
        { key: "fnsid", label: "FNSID", sortable: true },
        { key: "sernm", label: "Serial#" },
        {
          key: "pMake",
          label: "Manufacturer",
          sortable: true,
          style: "width: 250px"
        },
        { key: "pMode", label: "Model" },
        {
          key: "compl",
          label: "Complaint",
          sortable: true,
          tdClass: "complaintClass"
        },
        { key: "loctn", label: "FNS Status", sortable: true },
        { key: "status", label: "Process Status", sortable: true },
        { key: "location", label: "Location" },
        { key: "flag", label: "Flag", sortable: true },
        { key: "recvD", label: "Receive Date", sortable: true },
      ]
    },
    downloadExcel() {
      this.loading2019 = true;
      const params = this.excelDownloadParams;
      this.$http
        .get(this.excelDownloadUrl, { params, responseType: "blob" })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TableReport.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          err => {
            this.loading2019 = false;
            console.log(err);
          }
        );
    },
    setExcelDownloadData(url, params) {
      this.excelDownloadUrl = url;
      this.excelDownloadParams = { ...params, xml: "true" };
    },
    getApiData(url, params) {
      this.message = "";
      this.setExcelDownloadData(url, params);
      this.loading = true;
      this.$http.get(url, { params }).then(
        res => {
          if (res.data && res.data.records) {
            this.data = res.data.records;
            if (res.data.records && res.data.records.length > 0) {
              this.total = res.data.records.length;
              res.data.records.forEach(obj => {
                if (obj.price != undefined) {
                  this.totalPrice =
                    this.totalPrice + parseFloat(obj.price.replace("$", ""));
                }
              });
            }
            this.message = "";
          } else if (res.data && res.data.message) {
            this.message = res.data.message;
          }
          this.loading = false;
        },
        err => {
          this.loading = false;
          console.log(err);
        }
      );
    },
    fetchChartDataReceived() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        productModel: this.productModel,
        customer: this.manufacturer
      };
      this.getApiData("api/teleste/tables/received.php", params);
    },
    fetchChartDataShipped() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        productModel: this.productModel,
        customer: this.manufacturer,
        client: this.city
      };

      let shippedUrl = "api/teleste/tables/shipped.php";

      this.getApiData(shippedUrl, params);
    },
    fetchChartDataRepair() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        year: this.selectedYear,
        month: this.selectedMonth,
        prodModel: this.modelParam
      };
      this.getApiData("api/teleste/tables/repairAnalytics.php", params);
    },
    fetchChartDataCityPerGroup() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.prg,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/teleste/tables/shipped.php", params);
    },
    fetchChartDataBer() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        prodModel: this.modelParam
      };
      this.getApiData("api/teleste/tables/ber.php", params);
    },
    fetchChartDataEol() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/teleste/tables/eol.php", params);
    },
    fetchChartDataNtf() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/teleste/tables/ntf.php", params);
    },
    fetchChartDataWar() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        prodModel: this.modelParam
      };
      this.getApiData("api/teleste/tables/war.php", params);
    },
    fetchChartDataOem() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam
      };
      this.getApiData("api/teleste/tables/oem_backlog.php", params);
    },
    fetchChartDataOemShipped() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/teleste/tables/oem_delivered.php", params);
    },
    fetchChartDatabacklog() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        prodModel: this.modelParam,
        client: this.city
      };
      let backlogUrl = "api/teleste/tables/back.php";
      this.setTableBacklogColumns();
      this.getApiData(backlogUrl, params);
    },
    fetchSubBacklog() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam
      };
      this.getApiData("api/teleste/tables/subdivision_backlog.php", params);
    },
    fetchSubDelivered() {
      const params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/teleste/tables/subdivision_delivered.php", params);
    },
    fetchChartDataPart() {
      const params = {
        fns_part: this.fns_part,
        failure: this.failure,
        dateFrom: this.dateFromParam,
        dateTo: this.dateToParam
      };
      this.getApiData("api/teleste/tables/failureDataByPart.php", params);
    },
    fetchChartDataDesignator() {
      const params = {
        fns_part: this.fns_part,
        failure: this.failure,
        dateFrom: this.dateFromParam,
        dateTo: this.dateToParam
      };
      this.getApiData("api/teleste/tables/failureDataByDesignator.php", params);
    },
    fetchChartDataFailure() {
      const params = {
        fns_part: this.fns_part,
        failure: this.failure,
        dateFrom: this.dateFromParam,
        dateTo: this.dateToParam
      };
      this.getApiData("api/teleste/tables/failureDataByFailure.php", params);
    },
    fetchChartDataComplaint() {
      const params = {
        fns_part: this.fns_part,
        failure: this.failure,
        dateFrom: this.dateFromParam,
        dateTo: this.dateToParam
      };
      this.getApiData("api/teleste/tables/failureDataByComplaint.php", params);
    },
    fetchChartDataHistorical() {
      const params = {
        year: this.year
      };
      this.getApiData("api/teleste/tables/historical.php", params);
    },
    fetchChartDataProject() {
      const params = {
        client_location: this.locationParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.getApiData("api/teleste/tables/projects.php", params);
    }
  },
  watch: {
    data: function() {
      this.loading = false;
      if (this.data === undefined) {
        this.title = "No data found";
      }
    }
  },
  mounted() {
    if (this.type != "top") {
      if (this.location) {
        this.locationParam = this.location.substring(
          0,
          this.location.lastIndexOf("(")
        );
      }
      if (this.productGroup) {
        this.productGroupParam = this.productGroup.substring(
          0,
          this.productGroup.lastIndexOf("(")
        );
      }
      if (this.productModel) {
        this.modelParam = this.productModel.substring(
          0,
          this.productModel.lastIndexOf("(")
        );
      }
      this.title =
        this.type.toLocaleUpperCase() +
        " - " +
        this.productGroupParam +
        " in " +
        this.locationParam;
    } else {
      this.locationParam = this.location;
      this.productGroupParam = this.prg.substring(0, this.prg.lastIndexOf("("));
      this.title = this.prg + " Shipped to " + this.locationParam;
    }
    this.clientsId = this.clients;
    this.dateFromParam = this.date_from;
    this.dateToParam = this.date_to;
    this.selectedYear = this.year;
    this.selectedMonth = this.month;
    this.product = this.prodModel;
    this.manufacturer = this.customer;
    if (this.type === "Received" || this.type === "received") {
      this.fetchChartDataReceived();
    }
    if (this.type === "Shipped" || this.type === "shipped") {
      this.fetchChartDataShipped();
    }
    if (this.type === "Repair" || this.type === "repair") {
      this.fetchChartDataRepair();
    }
    if (this.type === "top") {
      this.fetchChartDataShipped();
    }
    if (this.type === "OEM") {
      this.fetchChartDataOem();
    }
    if (this.type === "OEMShip") {
      this.fetchChartDataOemShipped();
    }
    if (this.type === "ber" || this.type === "BER") {
      this.fetchChartDataBer();
    }
    if (this.type === "eol") {
      this.fetchChartDataEol();
    }
    if (this.type === "ntf") {
      this.fetchChartDataNtf();
    }
    if (this.type === "war") {
      this.fetchChartDataWar();
    }
    if (this.type === "backlog") {
      this.fetchChartDatabacklog();
    }
    if (this.type === "city") {
      this.fetchChartDataCityPerGroup();
    }
    if (this.type === "SubDivisionBacklog") {
      this.fetchSubBacklog();
    }
    if (this.type === "SubDivisionDelivered") {
      this.fetchSubDelivered();
    }
    let typeSplit = this.type.split("(");
    if (typeSplit[0] === "Part") {
      this.title = "Failure by Part";
      this.fetchChartDataPart();
    }
    if (typeSplit[0] === "Designator") {
      this.title = "Failure by Designator";
      this.fetchChartDataDesignator();
    }
    if (typeSplit[0] === "Failure") {
      this.title = "Failure by Failure";
      this.fetchChartDataFailure();
    }
    if (typeSplit[0] === "Complaint") {
      this.title = "Failure by Complaint";
      this.fetchChartDataComplaint();
    }
    if (this.type === "historical" || this.type === "HISTORICAL") {
      this.fetchChartDataHistorical();
    }
    if (this.type === "projects") {
      this.fetchChartDataProject();
    }
  }
};
</script>
<style>
.complaintClass {
  width: 200px;
}
.download-button {
  width: 150px;
  margin: auto;
  float: right;
  font-weight: 500;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.sk-double-bounce {
  display: inline-block;
  line-height: 55px;
  margin: auto;
}

.download-button:hover {
  text-decoration: none !important;
  color: white;
}
.fa-file-excel-o {
  color: #ffffff68;
  padding-right: 0.5em;
}
</style>
